import { ArrowRight } from "lucide-react";
import AnimatedButton from "../ui/animated-button";

const ActionButton = () => (
	<AnimatedButton href="https://app.everclose.com/quiz/quiz-vsl?m=req&ad=s3" primary>
		Get Started for FREE <ArrowRight className="ml-2 h-4 w-4" />
	</AnimatedButton>
);

export default ActionButton;
